import React from 'react'

import { AccountView } from './AccountView'

export const AccountContainer = () => {
  return <AccountView />
}

export default AccountContainer
